var m = require('mithril');
var chartByUnit = require('../../dashboards/components/chartByUnit');
var heading = require('../../components/heading');
var edit = require('../../layout/components/edit');
var builderEditView = require('../../libs/builderEditView');
var elementChartByUnits = {}


elementChartByUnits.oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.pointsByUnit = {}
  ctrl.element.out_Contains.map(function (outEdge) {
    var dataset = outEdge.in;
    if (!Array.isArray(dataset.out_Column)) {
      dataset.out_Column = []
    }
    
    dataset.out_Column.map(function (column) {
      column.permission = ctrl.element.permission;
      if(ctrl.pointsByUnit[column.in.unit]){
        ctrl.pointsByUnit[column.in.unit].push(column)
      }
      else{
        ctrl.pointsByUnit[column.in.unit] = [column]
      }
    })
  })
}

elementChartByUnits.view = function(){
  var ctrl = this;

  return m('div',[
    edit.vm.editing() || Object.keys(ctrl.pointsByUnit).length === 0 ? m(heading, {label: ctrl.element.name, class: 'f1', element: ctrl.element, parentReinitialize: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback}) : '',
    edit.vm.editing() ? 
      m(builderEditView, {element: ctrl.element, parentReinitialize: ctrl.parentReinitialize})
    :   
      m('div',[
        Object.keys(ctrl.pointsByUnit).map( key => { 
          return m('div',[
            m(heading, {label: 'Chart for "'+key+'".', class: 'f3'}),
            m(chartByUnit, {columns: ctrl.pointsByUnit[key]})
          ])
        })
      ])
  ])

}

module.exports = elementChartByUnits;